goog.provide("shadow.js.shim.module$$mui$material$FormHelperText");
goog.provide("module$shadow_js_shim_module$$mui$material$FormHelperText");
shadow.js.shim.module$$mui$material$FormHelperText = shadow.js.nativeProvides["@mui/material/FormHelperText"] = shadow$bridge("@mui/material/FormHelperText");
module$shadow_js_shim_module$$mui$material$FormHelperText.default = shadow.js.shim.module$$mui$material$FormHelperText;
